import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChatProvider } from '@/contexts';
import { ChatPage } from '@/pages';
import { FAQPage } from '@/pages/FAQPage';
import { FAQIndexPage } from '@/pages/FAQIndexPage';
import { DealershipsIndexPage } from '@/pages/DealershipsIndexPage';
import { DealershipPage } from '@/pages/DealershipPage';
import { VehiclesIndexPage } from '@/pages/VehiclesIndexPage';
import { VehiclePage } from '@/pages/VehiclePage';
import { CompareIndexPage } from '@/pages/CompareIndexPage';
import { ComparisonPage } from '@/pages/ComparisonPage';
import { ResearchIndexPage } from '@/pages/ResearchIndexPage';
import { ResearchPage } from '@/pages/ResearchPage';
import { TopicsPage } from '@/pages/TopicsPage';
import { ServicesIndexPage } from '@/pages/ServicesIndexPage';
import { ServicePage } from '@/pages/ServicePage';
import { Footer } from '@/components/layout/Footer';
import { CookieConsentProvider } from '@/components/cookie/CookieConsentProvider';
import { GTMProvider } from './components/retargeting/GTMprovider.tsx';
import { FacebookPixelProvider } from '@/components/retargeting/FacebookPixelProvider';
import { useChat } from '@/hooks';
import './styles/globals.css';

function AppContent() {
    const { selectedAssistant } = useChat();

    const showFooter = !selectedAssistant;

    return (
        <FacebookPixelProvider>
            <GTMProvider>
                <CookieConsentProvider
                    assistantName="GPTforMe"
                >
                    {(hasConsented, checkConsent, showBanner) => (
                        <div className="min-h-screen">
                            <Routes>
                                <Route path="/" element={<ChatPage showBanner={showBanner} />} />
                                <Route path="/lander" element={<Navigate to="/" replace />} />
                                <Route path="/faq" element={<FAQIndexPage />} />
                                <Route path="/faq/*" element={<FAQPage showBanner={showBanner} />} />
                                <Route path="/dealerships" element={<DealershipsIndexPage />} />
                                <Route path="/dealerships/:slug" element={<DealershipPage showBanner={showBanner} />} />
                                <Route path="/vehicles" element={<VehiclesIndexPage />} />
                                <Route path="/vehicles/:make/:model" element={<VehiclePage showBanner={showBanner} />} />
                                <Route path="/compare" element={<CompareIndexPage showBanner={showBanner} />} />
                                <Route path="/compare/:slug" element={<ComparisonPage showBanner={showBanner} />} />
                                <Route path="/research" element={<ResearchIndexPage showBanner={showBanner} />} />
                                <Route path="/research/:slug" element={<ResearchPage showBanner={showBanner} />} />
                                <Route path="/topics" element={<TopicsPage showBanner={showBanner} />} />
                                <Route path="/services" element={<ServicesIndexPage showBanner={showBanner} />} />
                                <Route path="/services/:slug" element={<ServicePage showBanner={showBanner} />} />
                            </Routes>
                            {showFooter && <Footer />}
                        </div>
                    )}
                </CookieConsentProvider>
            </GTMProvider>
        </FacebookPixelProvider>
    );
}

function App() {
    return (
        <BrowserRouter>
            <ChatProvider>
                <AppContent />
            </ChatProvider>
        </BrowserRouter>
    );
}

export default App;